export function tasksAdapter(allTasks) {
  const default_color = '#a5a6f6'
  const default_title = 'Title task'
  const items = allTasks.map((task) => {
    return {
      taskGroup: task.TaskGroup,
      attachment: task.attachment,
      child: task.child,
      complete_attachment: task.complete_attachment,
      complete_date: task.complete_date,
      date: task.date,
      description: task.description,
      dueDate: task.dueDate,
      due_date: task.due_date,
      due_section: task.due_section,
      duration: task.duration,
      duration_type: task.duration_type,
      end_date: task.end_date,
      hour: task.hour,
      id: task.id,
      isEvent: task.isEvent,
      is_due: task.is_due,
      notification_date: task.notification_date,
      notification_type: task.notification_type,
      parent_approved_completion: task.parent_approved_completion,
      parent_approved_creation: task.parent_approved_creation,
      parent_qualified_completion: task.parent_qualified_completion,
      priority: { 
        description: task.priority.description,
        id: task.priority.id,
        image: task.priority.image,
        value: task.priority.value,
      },
      project: task.project,
      repeat: task.repeat,
      repeat_date: task.repeat_date,
      repeat_date_date: task.repeat_date_date,
      repeat_date_hour: task.repeat_date_hour,
      repeat_text: task.repeat_text,
      start_date: task.start_date,
      start_date: task.start_date,
      state: task.state,
      state_name: task.state_name,
      subject: task.subject,
      subjectColor: !task.subjectColor ? default_color : `#${task.subjectColor}`,
      subject_name: task.subject_name,
      submitted: task.submitted,
      submitted: task.submitted,
      timeSpentSeconds: task.timeSpentSeconds,
      title: !task.title ? default_title : `${task.title}`,
      type_text: task.type_text,
    };
  });
  return items;
}


